import { registerDecorator, ValidationOptions, ValidationArguments } from "class-validator";

export function MinusGtrZero(property: string, validationOptions?: ValidationOptions) {
    return function (object: Object, propertyName: string) {
        registerDecorator({
            name: "minusGtrZero",
            target: object.constructor,
            propertyName: propertyName,
            constraints: [property],
            options: validationOptions,
            validator: {
                validate(value: any, args: ValidationArguments) {
                    const [relatedPropertyName]: string[] = args.constraints;
                    const relatedValue: number = (args.object as any)[relatedPropertyName];
                    const retVal: boolean = typeof value === "number" && typeof relatedValue === "number" && value - relatedValue >= 0;
                    return retVal;
                },
            },
        });
    };
}
